import store from '@/store';

export const notify = (title, message, type) => {
  store.commit('addNotification', {
    title,
    message,
    type
  });
}

export const notifySuccess = (title, message) => notify(
  title,
  message,
  'success'
);

export const notifyError = (title, message) => notify(
  title,
  message,
  'danger'
);

export const notifyWarning = (title, message) => notify(
  title,
  message,
  'warning'
)
